import { ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Text, Button } from '@chakra-ui/react';
import { colors } from 'constants/constants';
import slugifyUnitName from 'helpers/slugifyUnitName';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { FacilityContent } from 'types/umbraco';


interface FacilityCardProps {
    facility: FacilityContent
}

const UnitCard = ({ facility }: FacilityCardProps): JSX.Element => {
    return (
        <Box style={{
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "4px"
        }}>
            <Box
                zIndex={2}
                position="relative"
                style={{ aspectRatio: '16/10' }}>
                <Image layout="fill" src={facility.image.url} />
            </Box>
            <Box style={{ padding: '26px 20px' }}>
                <Text mb={3} color={colors.secondary.darkGrey} fontWeight={600} fontSize={24}>
                    {facility.name}
                </Text>
                <Text>{facility.address.split(',')[0]}</Text>
                {facility.address.split(',').length > 0 && <Text mb={5}>{facility.address.split(',')[1]}</Text>}
                <Link href={facility.url.replace('/website/anlaggningar', '/anlaggning')}>
                    <Button variant="ml" size="lg" paddingX={10} fontWeight="400">Boka<ChevronRightIcon ml={3} /></Button>
                </Link>
            </Box>
        </Box>
    );
};

export default UnitCard;